import React, {
  forwardRef,
  ReactElement,
  Ref,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import {
  fetchFiltersDropdownValues,
  fetchOrderListByFilter,
  updateExportToExcelPath,
  resetRepushOrder,
  resetReassignCarrier,
  resetOrderListError,
  saveColumnSettings,
  updateColumnSettings,
  resetViewCreationStatus,
  resetViewUpdationStatus,
} from "./redux/orderListSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  createFilterPayload,
  lastMileCountryDataTransform,
  getErrorStatusMsg,
  getErrorStatusFieldReadMore,
} from "../mocks/orderList/response.transforms";
import { AppState } from "../config/redux/reducers";
import { useStyles } from "./OrderList.styles";
import AppConstants from "../constants";
import { Box, Grid, Switch, Typography } from "@material-ui/core";
import GridWrapper from "../common/GridWrapperV2";
import ConsignmentDetails from "./ConsignmentDetails";
import PrintShippingLabel from "../SharedComponent/components/PrintShippingLabel";
import moment from "moment";
import Loader from "../common/Loader";
import CustomStatusBar from "../common/CustomStatusBar";
import { userLogout } from "../Login/redux/loginSlice";
import _ from "lodash";
import {
  CellParams,
  RowData,
  SortModel,
  RowParams,
  SelectionChangeParams,
} from "../common/GridWrapperV2/DataTable";
import ExportInitiatedDialog from "ExportIntiaiedDialog";
import CustomTooltip from "common/Tooltip";
import { TextConstants } from "constants/TextConstants";
import {ReactComponent as TruckIcon} from './../assets/icons/Truck.svg';

const OrderList = (props: any) => {
  const dispatch = useDispatch();

  const componentClasses = useStyles();

  const snackbarType = useRef(AppConstants.SNACKBAR.TYPES.SUCCESS);
  const snackbarMessage = useRef("");

  const {
    data,
    filtersDropdowns,
    tableLoading,
    loading,
    columnList,
    favoriteViews,
    error,
    errorCode,
    repushOrderMsg,
    repushOrderFlag,
    reassignCarrierMsg,
    reassignCarrierFlag,
    viewCreationStatus,
    viewCreationMsg,
    viewUpdateStatus,
    viewUpdateMsg,
    exportInitiated,
    reportId,
  } = useSelector((state: AppState) => state.orderList);
  
  const { countryCode, hubRecordListWithCodeAndName } = useSelector((state: AppState) => state.common);
  const [isManuallyAssigned, setIsManuallyAssigned] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [listToShow, setListToShow] = useState([]);
  const [consignmentData, setConsignmentData] = useState({});
  const [
    openConsignmentDetailsPopup,
    setOpenConsignmentDetailsPopup,
  ] = useState(false);
  const [
    openPrintShippingLabelPopup,
    setOpenPrintShippingLabelPopup,
  ] = useState(false);
  const [selectedConsignments, setSelectedConsignments] = useState(
    [] as RowData[]
  );
  const [isColumnSettingsDisabled, setIsColumnSettingsDisabled] = useState(
    false
  );
  const [headerData, setHeaderData] = useState(
    columnList.freezed
      ? [...columnList.freezed, ...columnList.unfreezed]
      : [...columnList]
  );

   const getSwitchingProgressIcon = () => {
          return (
            <CustomTooltip title={TextConstants.MANUALLY_ASSIGNED}>
              <TruckIcon className={componentClasses.carrierSwitchingIcon}/>
            </CustomTooltip>
          );
      };

  const [tableWrapperData, setTableWrapperData] = useState({
    ...AppConstants.CONSIGNMENT_CONSTANTS.TABLE_WRAPPER_DATA,
    defaultFiltersObj: {
      ...AppConstants.CONSIGNMENT_CONSTANTS.TABLE_WRAPPER_DATA
        .defaultFiltersObj,
      dateRange: {
        startDate: moment().format(AppConstants.DATE_FORMAT),
        endDate: moment().format(AppConstants.DATE_FORMAT),
      },
      carriers: AppConstants.CONSIGNMENT_CONSTANTS.TABLE_WRAPPER_DATA
              .defaultFiltersObj.carriers,
      hub: AppConstants.CONSIGNMENT_CONSTANTS.TABLE_WRAPPER_DATA
              .defaultFiltersObj.hub,
    },
    HeaderData: headerData.map((header: any) => {
      const newHeader = { ...header };
      if (newHeader.field === "consignmentId") {
        newHeader.renderCell = (params: CellParams) => (
          <Grid container direction="row" alignItems="center" wrap="nowrap" style={{ width: '100%', overflow: 'hidden' }}>
          <Grid item className="idLink" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {params.value}
          </Grid>
          {params?.rowData?.switchingEnabled && (
            <Grid item style={{ flexShrink: 0 }}>
              {getSwitchingProgressIcon()}
            </Grid>
          )}
        </Grid>
        );
      }
      if (newHeader.field === "statusErrors") {
        newHeader.renderCell = (params: any) => (
          <Grid className={componentClasses.statusHeader}>
            <Grid item>{getErrorStatusMsg(params.value)}</Grid>
            <Grid item className="statusMsgMore">
              {getErrorStatusFieldReadMore(params.value)}
            </Grid>
          </Grid>
        );
      }
      return newHeader;
    }),
  });

  const [activeFilters, setActiveFilters] = useState(
    tableWrapperData.defaultFiltersObj
  );

  const fetchAllFilters = () => {
    dispatch(fetchFiltersDropdownValues());
  };

  const handleHeaderButtonsDisableState = useCallback(() => {
    const headerButtons = tableWrapperData.headerButtons.map((btn: any) => {
      switch (btn.name) {
        case "print":
          btn.disabled = !selectedConsignments.length;
          break;
        case "excel":
          btn.disabled = !listToShow.length;
          break;
        case "colsettings":
          setIsColumnSettingsDisabled(btn.disabled);
          break;
        default:
          break;
      }
      return btn;
    });
    setTableWrapperData({ ...tableWrapperData, headerButtons: headerButtons });
  }, [tableWrapperData, selectedConsignments, listToShow]);

  const handleLoadMoreDisableState = useCallback(() => {
    const loadMoreState = tableWrapperData.loadMore;
    loadMoreState.disabled = data.totalPages
      ? data.pageNumber + 1 >= data.totalPages
      : true;
    setTableWrapperData({ ...tableWrapperData, loadMore: loadMoreState });
  }, [tableWrapperData, data]);

  const filterCallback = (filters: any, isLoadMore?: boolean, manualAssignment?: boolean) => {
    if (filters) {
      const requestContinuationToken = data.continuationToken;
      const payloadFilters = _.cloneDeep(filters);
      payloadFilters[AppConstants.COUNTRY_CODE] =
        sessionStorage.getItem(AppConstants.COUNTRY_CODE) ||
        countryCode;
      
      let manualAssignmentValue = manualAssignment
      if(manualAssignment === undefined){
        const isResettingToDefault = filters._isReset === true;
        if(isResettingToDefault) setIsManuallyAssigned(false);
          manualAssignmentValue = isResettingToDefault ? false : isManuallyAssigned;
        }
      delete payloadFilters._isReset;
      delete filters._isReset;
      const payload = createFilterPayload(payloadFilters, data, isLoadMore, manualAssignmentValue);
      if (payload.page) {
        payload.requestContinuationToken = requestContinuationToken;
      }
      // Store the active filters
    if (!isLoadMore) {
      setActiveFilters(filters);
    }
      dispatch(
        fetchOrderListByFilter({
          filters: payload,
        })
      );
    }
  };

  const fetchOrder = (
    searchBy: string,
    value: string,
    filters: any,
    isLoadMore: boolean
  ) => {
    if (searchBy && value) {
      let page = 0;
      if (isLoadMore) {
        page = data.pageNumber + 1 <= data.totalPages ? data.pageNumber + 1 : 0;
      }
      const requestContinuationToken = data.continuationToken;

      const payload = { page: page } as any;
      if (payload.page) {
        payload.requestContinuationToken = requestContinuationToken;
      }
      const activeFilters = _.cloneDeep(filters);
      activeFilters.searchAttribute = {
        key: searchBy,
        value: value,
      };
      filterCallback(activeFilters);
    }
  };

  const openSnackbarPopup = (msg: string, type: string) => {
    snackbarMessage.current = msg;
    snackbarType.current = type;
    setOpenSnackbar(true);
  };

  const handleExcelExport = (filters: any) => {
    if (filters) {
      if (
        data.totalElements >
        AppConstants.CONSIGNMENT_CONSTANTS.DISABLE_EXPORT_EXCEL
      ) {
        openSnackbarPopup(
          AppConstants.CONSIGNMENT_CONSTANTS.DISABLE_EXPORT_EXCEL_MSG,
          AppConstants.SNACKBAR.TYPES.ERROR
        );
      } else {
        const payloadFilters = _.cloneDeep(filters);
        payloadFilters[AppConstants.COUNTRY_CODE] =
          sessionStorage.getItem(AppConstants.COUNTRY_CODE) ||
          countryCode;
        const payload = createFilterPayload(payloadFilters, data, false, isManuallyAssigned);
        dispatch(
          updateExportToExcelPath({
            payload: payload,
          })
        );
      }
    }
  };

  const searchFilterHandler = (
    data: { [key: string]: string },
    filters: any,
    isLoadMore: boolean
  ) => {
    const searchKey = Object.keys(data)[0];
    if (searchKey) {
      data[searchKey] = _.trim(data[searchKey]);
      if (
        data[searchKey] &&
        data[searchKey].length >= AppConstants.SEARCH_BOX_LIMIT
      ) {
        fetchOrder(searchKey, data[searchKey], filters, isLoadMore);
      } else {
        openSnackbarPopup(
          AppConstants.SEARCH_TEXT_LIMIT,
          AppConstants.SNACKBAR.TYPES.ERROR
        );
      }
    }
  };

  const handleRowClick = (params: RowParams) => {
    if (data && params.data) {
      const selectedRow = params.data;
      const selectedConsignment = data.content.filter(
        (item: any) => item.consignmentCode === selectedRow.consignmentId
      );
      const consignment = selectedConsignment.length
        ? { ...selectedConsignment[0], tableRecord: selectedRow }
        : { tableRecord: selectedRow };
      setConsignmentData(consignment);
      setOpenConsignmentDetailsPopup(true);
    }
  };

  const updateSelectedRows = (params: SelectionChangeParams) => {
    setSelectedConsignments(params.rows);
  };

  const handleHeaderButtonClick = (btnObj: any) => {
    if (btnObj && btnObj.type) {
      switch (btnObj.type) {
        case "print":
          setOpenPrintShippingLabelPopup(true);
          break;
        case "excel":
          handleExcelExport(btnObj.params);
          break;
        default:
          break;
      }
    }
  };

  const closeConsignmentDetailsPopup = () => {
    setOpenConsignmentDetailsPopup(false);
    setConsignmentData({});
  };

  const closePrintShippingLabelPopup = () => {
    setOpenPrintShippingLabelPopup(false);
  };

  const saveColumnSetting = useCallback(
    (params: any) => {
      dispatch(
        saveColumnSettings({
          itemList: params.itemsList,
          viewName: params.values.viewName,
        })
      );
      setHeaderData([...params.itemsList]);
      const headerDataTmp = [...params.itemsList];
      setTableWrapperData({
        ...tableWrapperData,
        HeaderData: headerDataTmp.map((header: any) => {
          const newHeader = { ...header };
          if (newHeader.field === "statusErrors") {
            newHeader.renderCell = (params: any) => (
              <Grid className={componentClasses.statusHeader}>
                <Grid item>{getErrorStatusMsg(params.value)}</Grid>
                <Grid item className="statusMsgMore">
                  {getErrorStatusFieldReadMore(params.value)}
                </Grid>
              </Grid>
            );
          }
          return newHeader;
        }),
      });
    },
    [dispatch, tableWrapperData, componentClasses]
  );

  const updateColumnSetting = useCallback(
    (params: any) => {
      dispatch(
        updateColumnSettings({
          itemList: params.itemList,
          viewName: params.viewName,
        })
      );
      const itemListArr = params.itemList;
      setHeaderData(
        itemListArr.freezed
          ? [...itemListArr.freezed, ...itemListArr.unfreezed]
          : [...params.itemList]
      );
      const headerDataTmp = itemListArr.freezed
        ? [...itemListArr.freezed, ...itemListArr.unfreezed]
        : [...params.itemList];
      setTableWrapperData({
        ...tableWrapperData,
        HeaderData: headerDataTmp.map((header: any) => {
          const newHeader = { ...header };
          if (newHeader.field === "statusErrors") {
            newHeader.renderCell = (params: any) => (
              <Grid className={componentClasses.statusHeader}>
                <Grid item>{getErrorStatusMsg(params.value)}</Grid>
                <Grid item className="statusMsgMore">
                  {getErrorStatusFieldReadMore(params.value)}
                </Grid>
              </Grid>
            );
          }
          return newHeader;
        }),
      });
    },
    [dispatch, tableWrapperData, componentClasses]
  );

  const handleColumnSettingsActions = useCallback(
    (params: any) => {
      if (params.type === "save") {
        saveColumnSetting(params);
      }
    },
    [saveColumnSetting]
  );

  const handleOnChangeFavoriteView = useCallback(
    (params: any) => {
      const activeView = favoriteViews
        ? _.find(favoriteViews, (n) => {
            return n.viewName === params;
          })
        : "";
      const payload = { viewName: "", itemList: [] };
      payload.itemList = activeView.colList;
      payload.viewName = activeView.viewName;
      updateColumnSetting(payload);
    },
    [favoriteViews, updateColumnSetting]
  );
  const [openExportInitiatedInfo, setOpenExportInitiatedInfo] = useState(false);
  const handleDialogClose = () => {
    setOpenExportInitiatedInfo(false);
  };

  useEffect(() => {
    if (exportInitiated) {
      setOpenExportInitiatedInfo(true);
    }
  }, [exportInitiated]);

  const handleSessionExpired = useCallback(() => {
    if (
      errorCode ===
      AppConstants.CONSIGNMENT_CONSTANTS.RESPONSE_CONSTANTS.ERROR_CODES
        .SESSION_TIMEOUT
    ) {
      dispatch(userLogout());
    }
    if (snackbarType.current === AppConstants.SNACKBAR.TYPES.SUCCESS) {
      if (viewCreationStatus) {
        dispatch(resetViewCreationStatus());
      }
      if (viewUpdateStatus) {
        dispatch(resetViewUpdationStatus());
      }
    }
    if (snackbarType.current === AppConstants.SNACKBAR.TYPES.ERROR) {
      dispatch(resetOrderListError());
    }
  }, [dispatch, errorCode, viewCreationStatus, viewUpdateStatus]);

  const handleSnackbarClose = useCallback(() => {
    setOpenSnackbar(false);
    handleSessionExpired();
  }, [handleSessionExpired]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpenSnackbar(false);
      handleSessionExpired();
    }, AppConstants.SNACKBAR.AUTO_HIDE_TIMEOUT);
    return () => clearTimeout(timer);
  });

  useEffect(() => {
    if (error) {
      openSnackbarPopup(error, AppConstants.SNACKBAR.TYPES.ERROR);
    }
  }, [error]);

  useEffect(() => {
    if (repushOrderFlag) {
      setOpenConsignmentDetailsPopup(false);
      openSnackbarPopup(repushOrderMsg, AppConstants.SNACKBAR.TYPES.SUCCESS);
      dispatch(resetRepushOrder());
    }
    if (reassignCarrierFlag) {
      setOpenConsignmentDetailsPopup(false);
      openSnackbarPopup(
        reassignCarrierMsg,
        AppConstants.SNACKBAR.TYPES.SUCCESS
      );
      dispatch(resetReassignCarrier());
    }
  }, [dispatch, repushOrderFlag, reassignCarrierFlag]);

  useEffect(() => {
    if (viewCreationStatus) {
      openSnackbarPopup(viewCreationMsg, AppConstants.SNACKBAR.TYPES.SUCCESS);
    }
  }, [viewCreationStatus]);

  useEffect(() => {
    if (viewUpdateStatus) {
      openSnackbarPopup(viewUpdateMsg, AppConstants.SNACKBAR.TYPES.SUCCESS);
    }
  }, [viewUpdateStatus]);

  useEffect(() => {
    setListToShow(lastMileCountryDataTransform(data) as any);
    handleLoadMoreDisableState();
  }, [data]);

  useEffect(() => {
    handleHeaderButtonsDisableState();
  }, [listToShow, selectedConsignments]);

  useEffect(() => {
    const filterFormData = tableWrapperData.FilterFormData.map(
      (filter: any) => {
        if (filter.fieldName === "hub") {
          filter.items =
            hubRecordListWithCodeAndName[
              sessionStorage.getItem(AppConstants.COUNTRY_CODE) || countryCode
            ] || [];
        }
        if (filter.fieldName === "carriers") {
          filter.items =
            (countryCode &&
              filtersDropdowns.carrierList[countryCode]) ||
            filtersDropdowns.carrierList[countryCode] ||
            [];
        }
        if (filter.fieldName === "deliveryStatus") {
          filter.items =
            (countryCode &&
              filtersDropdowns.statusList[countryCode]) ||
            filtersDropdowns.statusList[countryCode] ||
            [];
        }
        if (filter.fieldName === "proposition") {
          filter.items =
            (countryCode &&
              filtersDropdowns.delPropositionList[countryCode]) ||
            filtersDropdowns.delPropositionList[countryCode] ||
            [];
        }
        return filter;
      }
    );
    setTableWrapperData({
      ...tableWrapperData,
      FilterFormData: filterFormData,
    });
    //filterCallback(tableWrapperData.defaultFiltersObj);
  }, [countryCode, hubRecordListWithCodeAndName]);

  useEffect(() => {
    if (tableWrapperData && tableWrapperData.FilterFormData) {
      const filterFormData = tableWrapperData.FilterFormData.map(
        (filter: any) => {
          if (filter.fieldName === "hub") {
            filter.items = hubRecordListWithCodeAndName[
              sessionStorage.getItem(AppConstants.COUNTRY_CODE) ||
                countryCode ||
                AppConstants.COUNTRY_OBJ.value
            ] || [];
          }
          if (filter.fieldName === "carriers") {
            filter.items =
              filtersDropdowns.carrierList[
                sessionStorage.getItem(AppConstants.COUNTRY_CODE) ||
                  countryCode ||
                  AppConstants.COUNTRY_OBJ.value
              ] || [];
          }
          if (filter.fieldName === "deliveryStatus") {
            filter.items =
              filtersDropdowns.statusList[
                sessionStorage.getItem(AppConstants.COUNTRY_CODE) ||
                  countryCode ||
                  AppConstants.COUNTRY_OBJ.value
              ] || [];
          }
          if (filter.fieldName === "proposition") {
            filter.items =
              filtersDropdowns.delPropositionList[
                sessionStorage.getItem(AppConstants.COUNTRY_CODE) ||
                  countryCode ||
                  AppConstants.COUNTRY_OBJ.value
              ] || [];
          }
          return filter;
        }
      );
      setTableWrapperData({
        ...tableWrapperData,
        FilterFormData: filterFormData,
      });
    }
  }, [filtersDropdowns, hubRecordListWithCodeAndName, countryCode]);

    const createUpdatedFilter = (filters: any) => {
        const clonedFilter = _.cloneDeep(filters);
        clonedFilter.page = 0;
        return clonedFilter;
      };

  const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newToggleValue = event.target.checked;
    setIsManuallyAssigned(newToggleValue);
    
    // Get current filters from tableWrapperData
    const updatedFilters = createUpdatedFilter(activeFilters);
    
    // Call filterCallback with updated filters and toggle value
    filterCallback(updatedFilters, false, newToggleValue);
};


   const renderCustomFilter = () => {
          return (
            <Grid container alignItems="center" >
                <Box  className={componentClasses.customFilter}>
                  <Typography style={{ fontSize: "12px" }}>
                    {"View Manual Assignments"}
                  </Typography>
                  <Switch
                    checked={isManuallyAssigned}
                    onChange={handleToggle}
                    color="primary"
                  />
                </Box>
            </Grid>
          );
        };

  return (
    <div className={componentClasses.root}>
      {loading && <Loader></Loader>}
      {openSnackbar && (
        <CustomStatusBar
          open={openSnackbar}
          handleClose={handleSnackbarClose}
          message={snackbarMessage.current}
          type={snackbarType.current}
        />
      )}
      {openPrintShippingLabelPopup && (
        <PrintShippingLabel
          open={openPrintShippingLabelPopup}
          selectedRows={selectedConsignments}
          closePopup={closePrintShippingLabelPopup}
        ></PrintShippingLabel>
      )}
      {openConsignmentDetailsPopup && (
        <ConsignmentDetails
          pageType={"order"}
          open={openConsignmentDetailsPopup}
          consignmentData={consignmentData}
          closePopup={closeConsignmentDetailsPopup}
        ></ConsignmentDetails>
      )}
      <Grid className={componentClasses.pageTitle}>Deliveries</Grid>
      <GridWrapper
        headerData={tableWrapperData.HeaderData}
        favoriteViews={favoriteViews}
        rowData={listToShow}
        loading={loading ? undefined : tableLoading}
        searchTypes={tableWrapperData.SEARCH_TYPES}
        filterForm={tableWrapperData.FilterFormData}
        defaultFilter={tableWrapperData.defaultFiltersObj}
        headerButtons={tableWrapperData.headerButtons}
        title={tableWrapperData.title}
        sortModel={tableWrapperData.sortModel as SortModel}
        loadMore={{
          ...tableWrapperData.loadMore,
          rowCount: data.totalElements || 0,
        }}
        onRowClick={handleRowClick}
        onSelectionChange={updateSelectedRows}
        headerBtnClick={handleHeaderButtonClick}
        searchCallback={searchFilterHandler}
        filterGrid={filterCallback}
        fetchAllFilters={fetchAllFilters}
        columnSettingsColList={columnList}
        isColumnSettingsDisabled={isColumnSettingsDisabled}
        onChangeFavoriteView={handleOnChangeFavoriteView}
        saveColumnSettingsActions={handleColumnSettingsActions}
        renderCustomFilter={renderCustomFilter}
      />
      {openExportInitiatedInfo && (
        <ExportInitiatedDialog
          openExportInitiatedInfo={openExportInitiatedInfo}
          handleDialogClose={handleDialogClose}
          reportId={reportId}
        />
      )}
    </div>
  );
};

export default OrderList;
